export const btnSty = {
  fontSize: "12px",
  fontFamily: "Inter",
  padding: "2px 14px",
  display: "flex",
  gap: 2,
  height: 36,
  background: "#EFE8F9",
  borderRadius: "12px",
};
